import React, { Component, Fragment } from 'react';
import CustomLoader from '../common/CustomLoader';
import { drapcodeIcon, iconForField } from '../../common/custom/icon-library';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import CustomSelect from '../../common/formElements/CustomSelect';
import * as Yup from 'yup';

export default class LayoutForm extends Component {
  getLayoutSchema = () => {
    const layout = this.props.layout ? this.props.layout : null;
    return {
      name: layout ? layout.name : '',
      header: layout ? layout.header : '',
      sidebar: layout ? layout.sidebar : '',
      footer: layout ? layout.footer : '',
    };
  };

  layoutSchemaValidation = () => {
    let validationSchema = {
      name: Yup.string()
        .required("Layout name can't be blank.")
        .max(100, 'Layout name can not be more than 100 characters.')
        .matches(/^[A-Za-z0-9\s]+$/, 'Layout name should not contain special characters.'),
      header: Yup.string().when(['sidebar', 'footer'], {
        is: (sidebar, footer) => !sidebar && !footer,
        then: Yup.string().required('Atleast one field (Header, Footer and Sidebar) is required.'),
      }),
      sidebar: Yup.string().when(['header', 'footer'], {
        is: (header, footer) => !header && !footer,
        then: Yup.string().required('Atleast one field (Header, Footer and Sidebar) is required.'),
      }),
      footer: Yup.string().when(['sidebar', 'header'], {
        is: (sidebar, header) => !sidebar && !header,
        then: Yup.string().required('Atleast one field (Header, Footer and Sidebar) is required.'),
      }),
    };
    return Yup.object().shape(validationSchema, [
      ['sidebar', 'footer'],
      ['header', 'footer'],
      ['sidebar', 'header'],
    ]);
  };

  handleSubmit = values => {
    this.props.handleSubmit(values);
  };

  closeNewLayout = () => {
    this.props.closeNewLayout();
  };

  headerOptions = () => {
    const { snippets } = this.props;
    let options = [];
    options = snippets ? snippets.map(e => ({ label: e.name, value: e.uuid })) : [];
    return options;
  };

  getLayoutForm = () => {
    return (
      <Formik
        enableReinitialize={true}
        initialValues={this.getLayoutSchema()}
        validationSchema={this.layoutSchemaValidation()}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          this.handleSubmit(values);
          setSubmitting(false);
          resetForm();
        }}
      >
        {({ isSubmitting, values, setFieldValue, setFieldTouched, errors }) => (
          <Form className="form-horizontal">
            <div className="row mx-auto">
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <div className="form-group">
                  <div className="input-group">
                    <div className="input-group-prepend" title="Layout Name">
                      <span className="input-group-text">
                        <i className={`wb ${iconForField('text')}`}></i>
                        <span className="required"> *</span>
                      </span>
                    </div>
                    <Field
                      type="text"
                      name="name"
                      className="form-control form-control-sm"
                      placeholder="Name of Layout"
                    />
                    <ErrorMessage name="name">
                      {msg => <p className="text-error">{msg}</p>}
                    </ErrorMessage>
                  </div>
                </div>
              </div>
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <div className="form-group">
                  <div className="input-group">
                    <div className="input-group-prepend" title="Header">
                      <span className="input-group-text">
                        <i className={`wb ${iconForField('select')}`}></i>
                      </span>
                    </div>
                    <CustomSelect
                      name="header"
                      isMulti={false}
                      onChange={setFieldValue}
                      onBlur={setFieldTouched}
                      options={this.headerOptions()}
                      value={values['header']}
                      placeholder="Select Header"
                    />
                    <ErrorMessage name={'header'}>
                      {msg => <p className="text-error">{msg}</p>}
                    </ErrorMessage>
                  </div>
                </div>
              </div>
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <div className="form-group">
                  <div className="input-group">
                    <div className="input-group-prepend" title="Sidebar">
                      <span className="input-group-text">
                        <i className={`wb ${iconForField('select')}`}></i>
                      </span>
                    </div>
                    <CustomSelect
                      name="sidebar"
                      isMulti={false}
                      onChange={setFieldValue}
                      onBlur={setFieldTouched}
                      options={this.headerOptions()}
                      value={values['sidebar']}
                      placeholder="Select Sidebar"
                    />
                    <ErrorMessage name={'sidebar'}>
                      {msg => <p className="text-error">{msg}</p>}
                    </ErrorMessage>
                  </div>
                </div>
              </div>
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <div className="form-group">
                  <div className="input-group">
                    <div className="input-group-prepend" title="Footer">
                      <span className="input-group-text">
                        <i className={`wb ${iconForField('select')}`}></i>
                      </span>
                    </div>
                    <CustomSelect
                      name="footer"
                      isMulti={false}
                      onChange={setFieldValue}
                      onBlur={setFieldTouched}
                      options={this.headerOptions()}
                      value={values['footer']}
                      placeholder="Select Footer"
                    />
                    <ErrorMessage name={'footer'}>
                      {msg => <p className="text-error">{msg}</p>}
                    </ErrorMessage>
                  </div>
                </div>
              </div>
              <div className="col-md-12 col-lg-12 text-right">
                <button type="button" className="btn btn-default" onClick={this.closeNewLayout}>
                  <span>
                    <i className="wb webconnect-times"></i>&nbsp;Cancel
                  </span>
                </button>
                &nbsp;
                <button
                  type="submit"
                  className="btn btn-theme-submit btn-md"
                  disabled={isSubmitting ? 'disabled' : ''}
                >
                  <i className={`wb ${drapcodeIcon('save')}`}></i> Save&nbsp;
                  {/* <CustomLoader
                        loading={changeDefaultPagePending !== undefined && changeDefaultPagePending}
                      /> */}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    );
  };

  render() {
    return <Fragment>{this.getLayoutForm()}</Fragment>;
  }
}
